import { NoDataType } from '@Components/types/NoDataType';
import { RequestListContext } from '@Components/types/RequestListContext';

type Output = {
  title: string;
  description: [string, string | undefined];
};

export const getText = (type: NoDataType): Output => {
  if (type === 'my-requests') {
    return {
      title: 'No Data',
      description: ['Please Select Request Type To Continue', undefined],
    };
  }

  if (type === 'approvals') {
    return {
      title: 'No Tasks Assigned',
      description: [
        'You Currently Have No Tasks Assigned To You.',
        'Please Check Back Later Or Contact Your Manager For More Details',
      ],
    };
  }

  if (type === 'empty-filters') {
    return {
      title: 'No Data',
      description: [
        "Filter can't find any item matching your request",
        undefined,
      ],
    };
  }

  if (type === 'empty-search') {
    return {
      title: 'No Data',
      description: [
        "Search can't find any item matching your request",
        undefined,
      ],
    };
  }

  if (type === 'empty-filters-search') {
    return {
      title: 'No Data',
      description: [
        "Search and filter can't find any item matching your request",
        undefined,
      ],
    };
  }

  if (type === 'confirmation') {
    return {
      title: 'No Data',
      description: ['Please Add Items To Proceed', undefined],
    };
  }

  if (type === 'comparison-screen') {
    return {
      title: 'No Data',
      description: ['Please Add Items For Comparison Sheet', undefined],
    };
  }

  if (type === 'documents') {
    return {
      title: 'No Documents',
      description: [
        "Search can't find any document matching your request",
        undefined,
      ],
    };
  }

  return {
    title: '',
    description: ['', undefined],
  };
};

export const getNoDataType = (
  context: RequestListContext,
  isSearchApplied: boolean,
  isFiltersApplied: boolean
): NoDataType => {
  if (isSearchApplied && !isFiltersApplied) {
    return 'empty-search';
  }

  if (!isSearchApplied && isFiltersApplied) {
    return 'empty-filters';
  }

  if (isSearchApplied && isFiltersApplied) {
    return 'empty-filters-search';
  }

  return context;
};
